import { DefaultBarChartUiOptions } from './utils/echart';

export const DefaultAreaChartProps = {
  type: 'area',
  displayName: 'Area chart',
  uiOptions: DefaultBarChartUiOptions,
} as const;
